export function contentsFeatured(contents, contentsList) {
    let contentArray;
    if (contents && contentsList) {
        contentArray = contents.filter((item) => {
            return contentsList.includes(item.id);
        });
    }
    return contentArray;
}

/**
 * Returns the content objects that belong to a group in the correct order the contents appear in a group.
 * @param contents - An array of content objects.
 * @param group - An array of content keys that belong to a specific group
 * @returns null if contents or group is null/undefined. Ordered array of contents in the group otherwise.
 */
export function filterGroupContents(contents, group) {
    if (!contents || !group || !group.contentKeys) {
        return null;
    }

    // Look through each content key for the contents in a group & push the corresponding content object into the groupContents array
    const groupedContents = [];
    group.contentKeys.forEach(groupContentId => {
        const currentContent = contents.find(content => groupContentId === content.id);
        if (currentContent) {
            groupedContents.push(currentContent);
        }
    });
    return groupedContents;
}



// WEBPACK FOOTER //
// ./src/app-lib/helpers/contents-helper.js